/**
 * 功能: 报告中插入数说附件的列表
 */
<template lang="pug">
  el-table(
    ref="sizeRef"
    :data="sizeData")
    el-table-column(
      prop="title"
      label="标题"
      show-overflow-tooltip)
    el-table-column(
      prop="authority"
      label="权威"
      width="70"
      align="center")
      template(slot-scope="scope")
        span {{ scope.row.authority | authority }}
    el-table-column(
      prop="status"
      label="状态"
      width="90")
      template(slot-scope="scope")
        span {{ scope.row.status | status }}
    el-table-column(
      prop="source"
      label="来自"
      width="120"
      align="center"
      show-overflow-tooltip)
      template(slot-scope="scope")
        span {{ scope.row.source }}
    //- el-table-column(
    //-   prop="industry"
    //-   label="行业"
    //-   width="120"
    //-   show-overflow-tooltip)
    //-   template(slot-scope="scope")
    //-     span(v-if="scope.row.industry" v-html="scope.row.industry.join('<br />')")
    el-table-column(
      prop="description"
      label="描述"
      show-overflow-tooltip)
    el-table-column(
      label="操作"
      width="80"
      align="center")
      template(slot-scope="scope")
        el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" @click="handleInsert(scope.row)") 插入

</template>

<script>
import drawSziePro from '@/views/size/components/drawsizePro'
export default {
  components: { drawSziePro },
  props: {
    sizeData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  methods: {
    handleInsert (sizeInfo) {
      sizeInfo._class = 2
      this.$emit('getInsertData', sizeInfo, () => {
        this.$message({
          type: 'success',
          message: '临时插入附件成功！'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
